import { Grid, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSwipeable } from "react-swipeable";
import "../../../Styles/ImageSwitcher.css";
import ReactImageMagnify from "react-image-magnify";

const ImageSwitcher = ({
  images,
  handleDialogOpen,
}: {
  images: string[];
  handleDialogOpen: (newImage: string) => void;
}) => {
  const [currentImage, setCurrentImage] = useState(images[0]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    setCurrentImage(images[currentImageIndex]);
  }, [images, currentImageIndex]);

  const handlers = useSwipeable({
    onSwipedLeft: () => handleNextImage(),
    onSwipedRight: () => handlePreviousImage(),
    delta: 10,
    trackMouse: false,
  });

  const [_error, setError] = useState(false);

  const handlePreviousImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Grid container direction="column" alignItems="center" >
      <Grid item onClick={() => handleDialogOpen(currentImage)} {...handlers} sx={{ position: "relative" }}>
      <ReactImageMagnify
        {...{
          smallImage: {
            alt: "Product",
            isFluidWidth: false,
            width: 430,
            height: 444,
            src: _error
              ? "/no-image.jpg"
              : `https://jewelryshopdoro.com/uploads/${currentImage}`,
            onError: () => setError(true),
          },
          largeImage: {
            src: _error
              ? "/no-image.jpg"
              : `https://jewelryshopdoro.com/uploads/${currentImage}`,
            width: 1200,
            height: 1600,
            onError: () => setError(true),
          },
          enlargedImagePosition: "over",
        }}
        style={{
          width: 430,
          height: 444,
          overflow: "hidden",
          display: "block",
          position: "relative",
        }}
        imageStyle={{
          objectFit: "cover",
          width: "100%",
          height: "100%",
        }}
      />
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            handlePreviousImage();
          }}
          sx={{
            position: "absolute",
            top: "50%",
            left: "0px",
            transform: "translateY(-50%)",
            zIndex: 10,
            color: "rgb(255, 244, 227)",
          }}
        >
          <ArrowBackIosIcon sx={{ fontSize: 48 }} />
        </IconButton>
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            handleNextImage();
          }}
          sx={{
            position: "absolute",
            top: "50%",
            right: "0px",
            transform: "translateY(-50%)",
            zIndex: 10,
            color: "rgb(255, 244, 227)"
          }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: 48 }} />
        </IconButton>
      </Grid>
      <Grid item className="small-images-row" sx={{ marginTop: "10px" }}>
        <Grid container direction="row" spacing={1} justifyContent="center">
          {images.map((image, index) => (
            <Grid item key={index} onClick={() => setCurrentImage(image)}>
              <img
                className="small-image-product"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  border: currentImage === image ? "3px solid #CF9B2E" : "none",
                  cursor: "pointer",
                  filter: currentImage !== image ? "blur(1px) brightness(50%)" : "none",
                }}
                alt="small"
                src={`https://jewelryshopdoro.com/uploads/${image}`}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ImageSwitcher;